var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2883_191121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0322266,
    y: 0.84375,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2883_191121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28242 22.8438L8.88242 19.6438C8.66576 19.5604 8.46159 19.4604 8.26992 19.3438C8.07826 19.2271 7.89076 19.1021 7.70742 18.9688L4.73242 20.2188L1.98242 15.4688L4.55742 13.5188C4.54076 13.4021 4.53242 13.2896 4.53242 13.1813V12.5063C4.53242 12.3979 4.54076 12.2854 4.55742 12.1687L1.98242 10.2188L4.73242 5.46875L7.70742 6.71875C7.89076 6.58542 8.08242 6.46042 8.28242 6.34375C8.48242 6.22708 8.68242 6.12708 8.88242 6.04375L9.28242 2.84375H14.7824L15.1824 6.04375C15.3991 6.12708 15.6033 6.22708 15.7949 6.34375C15.9866 6.46042 16.1741 6.58542 16.3574 6.71875L19.3324 5.46875L22.0824 10.2188L19.5074 12.1687C19.5241 12.2854 19.5324 12.3979 19.5324 12.5063V13.1813C19.5324 13.2896 19.5158 13.4021 19.4824 13.5188L22.0574 15.4688L19.3074 20.2188L16.3574 18.9688C16.1741 19.1021 15.9824 19.2271 15.7824 19.3438C15.5824 19.4604 15.3824 19.5604 15.1824 19.6438L14.7824 22.8438H9.28242ZM12.0824 16.3438C13.0491 16.3438 13.8741 16.0021 14.5574 15.3188C15.2408 14.6354 15.5824 13.8104 15.5824 12.8438C15.5824 11.8771 15.2408 11.0521 14.5574 10.3688C13.8741 9.68542 13.0491 9.34375 12.0824 9.34375C11.0991 9.34375 10.2699 9.68542 9.59492 10.3688C8.91992 11.0521 8.58242 11.8771 8.58242 12.8438C8.58242 13.8104 8.91992 14.6354 9.59492 15.3188C10.2699 16.0021 11.0991 16.3438 12.0824 16.3438Z",
    fill: "#202020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.992a83d8583f1452ab3a4274c77fe8e0.svg";
export { ForwardRef as ReactComponent };